import { Box, Typography, Link } from '@mui/material'
import { styles } from './styles'

export const InvoicingInstruction = (): JSX.Element => (
  <Box sx={styles.invoicingContainer}>
    <Typography variant="body1">
      Please submit your invoice to us by either uploading it here or emailing it to us at{' '}
      <Link href="mailto:autismed@gvsu.edu" underline="hover">
        autismed@gvsu.edu
      </Link>
      .
    </Typography>
    <Typography variant="body1" sx={styles.invoicingNote}>
      Please Note: Payment cannot be issued unless an invoice is submitted to START using one of these methods.
    </Typography>
  </Box>
)
